<div
  class="d-flex align-items-center justify-content-center flex-column error-page vh-50">
  <h1>Something went wrong!</h1>
  <p>Please try again later.</p>
  <app-ao-button
    labelText="Navigate to Home"
    [severity]="'primary'"
    (buttonClick)="navigateHome()" />
</div>
